import React from "react";
import { Button } from "semantic-ui-react";
import styled from "styled-components";
import { palette } from "@conserveit/blocks";
import { Trans } from "@lingui/macro";
import SiteDetailsModal from "./SiteDetailsModal";

const StyledText = styled.p`
  color: ${palette.danger};
  text-transform: uppercase;
`;

const StyledButton = styled(Button)`
  width: 100px;
  padding-left: 0 !important;
  padding-right: 0 !important;
  color: ${palette.pureWhite} !important;
  background-color: ${palette.danger} !important;
`;

interface Props {
  onModalConfirm: () => void;
  onModalCancel: () => void;
}

const DiscardModal: React.FC<Props> = ({ onModalConfirm, onModalCancel }) => {
  return (
    <SiteDetailsModal
      iconSrc="https://conserveit-images.s3.ap-southeast-2.amazonaws.com/icons/site-details_rubbish-bin.png"
      iconAlt="Delete icon - red rubbish bin"
      actionDescription={
        <StyledText>
          <Trans id="site_details.modal.action_confirmation_discard">
            discard
          </Trans>
        </StyledText>
      }
      confirmButton={
        <StyledButton
          data-testid="discard-modal__discard-button"
          onClick={() => onModalConfirm()}
        >
          <Trans id="site_details.discard">Discard</Trans>
        </StyledButton>
      }
      onModalCancel={onModalCancel}
    />
  );
};

export default DiscardModal;
